var app = angular.module('leonardo');

var FieldService = function(BaseRestService) {
  return new BaseRestService('fields');
};

app.factory('FieldService', ['BaseRestService', FieldService]);
